import { 
  FOCUS_PLANNING,
  SET_HISTORY,
  SET_HISTORY_FILTER,
  SET_PLANNING, 
  SET_PLANNINGS, 
  SET_HISTORY_LOADING, 
  SET_PROCESS_HISTORY,
  SET_TOTAL_PAGES,
  SET_PROCESS_PAGE_CACHE,
  SET_PLANNING_STATUS_CODE
} from '../types';
import { Filter } from '../../components/UserManagement/PlanningTable/PlanningTable';

export function setPlannings (data: object) {
  return {
    type: SET_PLANNINGS,
    data: data
  };
}

export function setPlanning (id: string) {
  return {
    type: SET_PLANNING,
    data: id
  };
}

export function focusPlanning (id: string) {
  return {
    type: FOCUS_PLANNING,
    data: id
  };
}

export const setHistory = (history: any) => ({
  type: SET_HISTORY,
  data: history,
});

export const setHistoryFilter = (filters: Filter[]) => ({
  type: SET_HISTORY_FILTER,
  data: filters,
});

export const setHistoryLoading  = (loading: boolean) => {
  return {
    type: SET_HISTORY_LOADING,
    data: loading
  };
};

export const setProcessHistory  = (history: boolean) => {
  return {
    type: SET_PROCESS_HISTORY,
    data: history
  };
};
export const setTotalPages = (data:any) => ({
  type: SET_TOTAL_PAGES,
  data
});
export const setProcessPageCache = (page: number, results: any[]) => ({
  type: SET_PROCESS_PAGE_CACHE,
  data: { page, results },
});
export const setPlanningStatusCode = (statusCode:number) => ({
  type: SET_PLANNING_STATUS_CODE,
  data:statusCode
});
